import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const MARKETING_ROUTES = [
  "/financial-plan",
  "/independent-financial-advisor",
  "/financial-advisor",
  "/financial-planning",
  "/financial-strategy",

  "/personal-financial-planning",
  "/personal-financial-strategy",

  "/wealth-management-for-indians-and-nri",
  "/wealth-management-strategy-for-indians-and-nri",
  "/wealth-management-for-nri-hni",

  "/investment-planning",
  "/investmentplanning",
  "/investment-advice",
  "/investment-strategy",

  "/financial-advice",
  "/financial-planning-strategy",

  "/retirement-planning",
  "/retirement-strategy",

  "/thankyou-page",
  "/global-advisory-thank-you",
  "/waitlist-thank-you",
  "/itr-filing-thankyou-page",
  "/review",
  "/retirement-planner",
  "/portfolio-management-services",
  "/meet-greet-pune",

  "/womoneya",
  "/womoneya-choice",
  "/india-ai-hedge-webinar",
  "/itr-filing-corporate",
  "/itr-filing-retail",
  "/itr-file-retail",
  "/itr-filing-retail-plans",
  "/itr-filing-partnerships",
  "/waiting-list",
  "/fintoo-ai-waitlist",
  "/tools",
  "/tokens",
  "/download-app",
  "/financial-clarity-score",
  "/financial-planning-services",
  "/financial-planning-consultation",
  "/waitlist",
  "/answers",
  "/app",
  "/fintoo-ai-answers",
  "/fintoo-ai-app",
  "/answers-to-your-money",
  "/ai-advisory",
  "/gff",
  "/private-wealth",
  "/executive-wealth",
  "/wealth-management-investment-planning",
  "/sebi-registered-financial-advisor",
  "/global-investment-advisory",
  "/global-advisory",
  "/fintoo-ai-preview",
  "/invest-in-us-stocks-from-india"  ,
  "/global-portfolio-advisory",
  
];

function AppRouter() {
  const [Shell, setShell] = useState(null);
  const { pathname } = useLocation();

  const isMarketingRoute = MARKETING_ROUTES.some(
    (p) => pathname === p || (p !== "/" && pathname.startsWith(p + "/")),
  );

  useEffect(() => {
    let cancelled = false;
    setShell(null);

    const loadShell = isMarketingRoute
      ? import("./MarketingApp")
      : import("./AppShell");

    loadShell.then((m) => {
      if (!cancelled) setShell(() => m.default);
    });

    return () => {
      cancelled = true;
    };
  }, [isMarketingRoute]);

  if (!Shell) return null;

  return <Shell />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}
